'use client';

import React, { useState } from 'react';

type WorkWeekToggleProps = {
  workWeek: 'five' | 'six';
  setWorkWeek: (week: 'five' | 'six') => void;
};

const WorkWeekToggle = ({ workWeek, setWorkWeek }: WorkWeekToggleProps) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(!open);
  const selectWeek = (week: 'five' | 'six') => {
    setWorkWeek(week);
    setOpen(false);
  };

  return (
    <div className="relative inline-block text-left mt-4">
      <button
        type="button"
        onClick={toggleOpen}
        className="inline-flex justify-center w-48 px-4 py-2 bg-[#0d47a1] text-white font-semibold rounded shadow hover:bg-[#0b3b88] focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
      >
        {workWeek === 'five' ? '5 dienų savaitė' : '6 dienų savaitė'}
        <svg
          className="ml-2 -mr-1 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.584l3.71-4.354a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {/* Dropdown options */}
      {open && (
        <div className="absolute mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
          <div className="py-1">
            <button
              className={`block w-full text-left px-4 py-2 ${
                workWeek === 'five' ? 'bg-blue-100 text-blue-800' : 'text-gray-700 hover:bg-gray-100'
              }`}
              onClick={() => selectWeek('five')}
            >
              5 dienų savaitė
            </button>
            <button
              className={`block w-full text-left px-4 py-2 ${
                workWeek === 'six' ? 'bg-blue-100 text-blue-800' : 'text-gray-700 hover:bg-gray-100'
              }`}
              onClick={() => selectWeek('six')}
            >
              6 dienų savaitė
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkWeekToggle;
